// extracted by mini-css-extract-plugin
export default {"cardWrapper":"Cards_cardWrapper__4dxuH","head":"Cards_head__UHNI9","main":"Cards_main__bDnaS","cardHead":"Cards_cardHead__yZJ4S"};